module.exports = __webpack_public_path__ + "static/media/product_23.b3c1e769.png";